import { DimensionsContext } from '@contexts/dimensions'
import { useRefDimensions } from '@hooks/use-ref-dimensions'
import React, { type FC, type PropsWithChildren, useRef } from 'react'

const BoxWithDimensionsProvider: FC<PropsWithChildren> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>()
  const containerDimensions = useRefDimensions(containerRef)

  return (
    <div ref={containerRef}>
      <DimensionsContext.Provider value={containerDimensions}>
        {children}
      </DimensionsContext.Provider>
    </div>
  )
}

export default BoxWithDimensionsProvider
